import Vue from 'vue';
import { api } from "../../services/Api.js";


export function add_news_item_reaction({ state, dispatch }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
      // make api call
    return api
    .post(school,"add_news_reaction.php",payload)
    .then( result => { 
      // reload whole news item to get all reactions in the right order
      dispatch('get_news_item', {id:payload.article_id});
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_news_item_reaction: "+error);
      return error;
    })

   
    
  }